import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  const stashPendingInvite = () => {
    const queryParams = new URLSearchParams(state.url.split('?')[1] ?? '');
    const inviteToken = queryParams.get('invite');
    if (inviteToken) sessionStorage.setItem('pending_invite_token', inviteToken);
    const inviteAction = queryParams.get('action');
    if (inviteAction) sessionStorage.setItem('pending_invite_action', inviteAction);
  };

  if (auth.hasValidRefreshToken()) {
    return auth.refreshAccessToken().pipe(
      map((success) => {
        if (success) return true;
        stashPendingInvite();
        return router.createUrlTree(['/login']);
      }),
      catchError(() => {
        stashPendingInvite();
        return of(router.createUrlTree(['/login']));
      }),
    );
  }

  stashPendingInvite();
  return router.createUrlTree(['/login']);
};
